// extracted by mini-css-extract-plugin
export default {"wrapper":"ContractLink_wrapper__npQTC","disabled":"ContractLink_disabled__sCDi+"};